<template>
	<section :id="['container-' + index + '-' + titleData.type]" :class="['container-' + titleData.type]">
		<div class="container-title-image">
			<div class="title-logo">
				<img v-if="mainSettings.logo"  :src="`${mainSettings.logo}`" alt="" :style="{ 'max-height': mainSettings.logoMaxHeight, 'max-width': mainSettings.logoMaxWidth }">
			</div>

			<div class="title-image">
				<img v-if="titleData.config.titleImage"  :src="`${titleData.config.titleImage}`" alt="">
			</div>

			<div class="title-headline-wrapper" v-if="titleData.config.objectTitle">
				<div class="container-fluid p-0 px-sm-4">
					<div class="title-headline">
						<h1>{{ titleData.config.objectTitle }}</h1>
					</div>
				</div>
			</div>
		</div>

	</section>
</template>

<script>
export default {
	props: {
		titleData: {
			type: Object
		},
		index: {
			type: Number
		},
		mainSettings: {
			type: Object
		}
	}
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/design-aachen/titleComponent.scss";
</style>
